import React, { useContext } from 'react';

import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import FilterChip from '@totem/components/ui_components/filters/FilterChip';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';

import '../devices.css';

const styles = {
  filterChip: {
    marginLeft: '2rem',
    marginTop: '2rem',
  },
};

const DevicesFilterChips = () => {
  const { handleFilter, getFilterValues, getFilterOptions } =
    useContext(InputContext);

  const handleMultiFilterDelete = (key: string, value: string) => {
    const updated = getFilterValues(key).filter((val) => val !== value);
    handleFilter(key, updated);
  };

  const getOptionName = (key: string, value: string) => {
    const match = getFilterOptions(key).find((opt) => opt.value === value);
    return match ? (match.text as string) : '';
  };

  return (
    <>
      {getFilterValues('vendor').map((option) => (
        <FilterChip
          key={option}
          label={`Vendor: ${option}`}
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('vendor', option)}
        />
      ))}
      {getFilterValues('type').map((option) => (
        <FilterChip
          key={option}
          label={`Type: ${option}`}
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('type', option)}
        />
      ))}
      {getFilterValues('operatingSystem').map((option) => (
        <FilterChip
          key={option}
          label={`OS: ${option}`}
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('operatingSystem', option)}
        />
      ))}
      {getFilterValues('region').map((option) => (
        <FilterChip
          key={option}
          label={`Region: ${getOptionName('region', option)}`}
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('region', option)}
        />
      ))}
      {getFilterValues('building').map((option) =>
        option === EMPTY_ID ? (
          <FilterChip
            key={option}
            label="Building: Unassigned"
            style={styles.filterChip}
            onClose={() => handleMultiFilterDelete('building', option)}
          />
        ) : (
          <FilterChip
            key={option}
            label={`Building: ${getOptionName('building', option)}`}
            style={styles.filterChip}
            onClose={() => handleMultiFilterDelete('building', option)}
          />
        ),
      )}
      {getFilterValues('noBackup').map((option) => (
        <FilterChip
          key={option}
          label="No Backup"
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('noBackup', option)}
        />
      ))}
      {getFilterValues('staleBackups').map((option) => (
        <FilterChip
          key={option}
          label="Stale Backup"
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('staleBackups', option)}
        />
      ))}
      {getFilterValues('noAntiVirus').map((option) => (
        <FilterChip
          key={option}
          label="No Anti-Virus"
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('noAntiVirus', option)}
        />
      ))}
      {getFilterValues('incompleteDeviceType').map((option) => (
        <FilterChip
          key={option}
          label="Incomplete Device Type"
          style={styles.filterChip}
          onClose={() =>
            handleMultiFilterDelete('incompleteDeviceType', option)
          }
        />
      ))}
      {getFilterValues('operatingSystemPastEndOfSupport').map((option) => (
        <FilterChip
          key={option}
          label="OS Past End-of-Support"
          style={styles.filterChip}
          onClose={() =>
            handleMultiFilterDelete('operatingSystemPastEndOfSupport', option)
          }
        />
      ))}
      {getFilterValues('operatingSystemApproachingEndOfSupport').map(
        (option) => (
          <FilterChip
            key={option}
            label="OS Near End-of-Support"
            style={styles.filterChip}
            onClose={() =>
              handleMultiFilterDelete(
                'operatingSystemApproachingEndOfSupport',
                option,
              )
            }
          />
        ),
      )}
      {getFilterValues('lowDiskSpace').map((option) => (
        <FilterChip
          key={option}
          label="Low Disk Space"
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('lowDiskSpace', option)}
        />
      ))}
      {getFilterValues('isManaged').map((option) => (
        <FilterChip
          key={option}
          label={option === 'ACTIVE' ? 'Is Managed' : 'Is Not Managed'}
          style={styles.filterChip}
          onClose={() => handleMultiFilterDelete('isManaged', option)}
        />
      ))}
    </>
  );
};

export default DevicesFilterChips;
